import styled from "styled-components";
import { Button as MaterialUIButton } from "@mui/material";

export const Background = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 1152px;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  margin: 50px 50px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 480px) {
    margin: 50px 16px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 70px 0px;

  @media screen and (max-width: 480px) {
    padding: 0px;
  }
`;

export const Title = styled.h1`
  padding: 0px;
  margin: 0px;
  color: #191c1a;
  font-weight: 600;
  font-size: 34px;
  line-height: 124%;

  @media screen and (max-width: 480px) {
    font-weight: 600;
    font-size: 20px;
    line-height: 160%;
  }
`;

export const Subtitle = styled.h3`
  padding: 0px;
  margin: 0px;
  color: #191c1a;
  font-weight: 500;
  font-size: 20px;
  line-height: 160%;

  @media screen and (max-width: 480px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
  }
`;

export const Header = styled.h2`
  padding: 0px;
  margin: 0px;
  color: #191c1a;
  font-weight: 600;
  font-size: 24px;
  line-height: 133%;

  @media screen and (max-width: 480px) {
    font-weight: 600;
    font-size: 24px;
    line-height: 133%;
  }
`;

export const Paragraph = styled.p`
  padding: 0px;
  margin: 0px;
  color: #0f0f1e99; //+opacity?
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;

  @media screen and (max-width: 480px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 143%;
  }
`;

export const Link = styled.span`
  font-size: 16px;

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const Button = styled(MaterialUIButton)`
  width: 130px;
  padding: 0.25rem 1rem;
  border-radius: 0.375rem;
  height: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;
